import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../../services/api'
import './ChangeEmail.css'
import { MainLayout } from '../../Layout/MainLayout'
import { useAuth } from '../../context/AuthContext'


export function ChanegeEmail() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState('')
    const user = useAuth()

    const userId = user.user?.id
    const [form, setForm] = useState({
        newEmail: '',
    })

    function set(field: string, value: string) {
        setForm(prev => ({ ...prev, [field]: value }))
        setError('')
    }

    async function handleSubmit() {
        setLoading(true)
        setError('')
        try {
            await api.put(`user/${userId}`, {
                email: form.newEmail,

            })
            setSuccess(true)
            setTimeout(() => navigate('/catalogo'), 1800)
        } catch (e: any) {
            console.log(e)
            setError(e.response?.data?.message || 'Erro ao Atualizar senha')
        } finally {
            setLoading(false)
        }
    }

    if (success) return (
        <MainLayout>
            <div className="cu-success-wrap">
                <div className="cu-success-icon">✓</div>
                <h2 className="serif">E-mail atualizado!</h2>
                <p>Redirecionando para o painel...</p>
            </div>
        </MainLayout>
    )

    return (
        <MainLayout>
            <div className="container fade-in">
                <div className="breadcrumb">
                    <a onClick={() => navigate('/catalogo/')}>Catálogo</a>
                    <span className="sep">›</span>
                    <span>Atualizar E-mail</span>
                </div>

                <div className="cu-layout">
                    <div className="cu-header">
                        <div className="kicker">Gestão de Dados</div>
                        <h1 className="serif">Atualizar E-mail</h1>
                        <p>Adicione um e-mail válido.</p>
                    </div>

                    <div className="cu-form-card">
                        {error && <div className="cu-error">{error}</div>}

                        <div className="cu-section-label">Senhas</div>
                        <div className="cu-row">
                            <div className="field" style={{ flex: 1 }}>
                                <label>E-mail *</label>
                                <input
                                    type="text"
                                    value={form.newEmail}
                                    onChange={e => set('newEmail', e.target.value)}
                                    placeholder={user.user?.email}
                                />
                            </div>
                        </div>

                        <div className="cu-actions">
                            <button
                                className="btn btn-ghost"
                                onClick={() => navigate('/admin')}
                                disabled={loading}
                            >
                                Cancelar
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? 'Criando...' : 'Atualizar →'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    )
}